module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c1ba16dba17e433fb784331c76973bcc.png";